import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';


@Component({
  selector: 'app-ieg-auditlog-main',
  templateUrl: './ieg-auditlog-main.component.html',
  styleUrls: ['./ieg-auditlog-main.component.scss']
})
export class IEGAuditlogMainComponent implements OnInit {

  Current_Tab: string = "Project Management Audit";

  Current_tab_ID: string = "Audit";

  screencode: string;
  ScreenName:string;
  constructor(private activatedRoute: ActivatedRoute,private commonService:CommonService) {

  }



  ngOnInit(): void {
    this.screencode = this.activatedRoute.snapshot.params['code'];
    
    var OrgDetail = this.commonService.getOrganizationObject(localStorage.getItem("orgCode"));
    if(OrgDetail!=null)
      {
         switch(this.screencode.toLocaleLowerCase())
         {
           case "ist":
           this.ScreenName= OrgDetail.IST_DISPLAY_NAME;
            break;
            case "grants":
              this.ScreenName= OrgDetail.GRANTS_DISPLAY_NAME;
              break;
         }
      }

   // this.ScreenName= this.screencode.toUpperCase()
  }



  AuditClick() {

    this.Current_Tab = "Project Management Audit";

    this.Current_tab_ID = "Audit";

  }



  ActivityClick() {

    this.Current_Tab = "Project Management Activity";

    this.Current_tab_ID = "Activity";

  }



}
